// extracted by mini-css-extract-plugin
export default {"sortableLanguagesContainer":"sortable-languages-container__sortable-languages-container__H6W5A"};